import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrudImplementation} from '@shared/services/crud-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudMandantService extends CrudImplementation {
  protected url = '/v1/admin/mandants';

  /**
   * TODO
   * use Lang crud
   */
  getLngList(): Observable<any> {
    const url = '/v1/admin/dropdown/lng/';
    return this.http.get(this.serverRoot + url);
  } // getClientList

  /**
   * TODO
   * use tool crud
   */
  getToolsList(): Observable<any> {
    const url = '/v1/admin/dropdown/tools/';
    return this.http.get(this.serverRoot + url);
  } // getClientList

  /**
   * TODO: refactor, if possible
   */
  getMandantFormFields(): Observable<any> {
    const url = '/v1/admin/mandants/fields';
    return this.http.get(this.serverRoot + url);
  } // getMandantFormFields


}
